import { GETSEND_EMAIL } from "../actions/types";

const initialState = {
    email_user:"",
    email_pass:"",
    email_port:"",
    email_host:""
};

export default function (state=initialState,action) {
    const { type , payload } = action;
    switch(type){
        case GETSEND_EMAIL:
            return {
                email_user:payload.user,
                email_pass:payload.pass,
                email_port:payload.port,
                email_host:payload.host
            }
        default:
            return state
    }
}